export function getDate() {
    const now = new Date();

    // 获取日期
    const date = now.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    })

    // 获取星期
    const weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][now.getDay()];

    // 获取时间
    const time = now.toLocaleTimeString('zh-CN', { hour12: false });

    return {
        time,
        date,
        week:weekday
    }
}